// @flow
// @flow-runtime warn
import { useState, useCallback, useEffect } from 'react';
import isEmpty from 'ramda/es/isEmpty';

import { api, requestsGeneral } from 'app/api';

import { type RecipientsType } from './RecipientsTypes';


/**
 *  Получение всех получателей по имеющимся школам
 */

export const defaultRecipientsState = {};
type Schools = Array<number> | [number] | []

export default function useRecipientsData(schoolIds?: Schools, autoRequest?: boolean = true) {
  const [recipients, setRecipients] = useState<RecipientsType>(defaultRecipientsState);
  const [loading, setLoading] = useState(true);

  /**
   *  ЗАПРОС ПОЛУЧАТЕЛЕЙ
   */

  const handleRequestRecipients = useCallback(async (schoolIds_: ?Schools = schoolIds) => {
    if (!schoolIds_ || isEmpty(schoolIds_)) return false;
    const recipientsRes: RecipientsType | null = await api.request(
      requestsGeneral.Statements_GET_recipients, {
        error: 'Не удалось запросить список получателей',
        onChangeLoadingState: setLoading,
        params: {
          school_id: schoolIds_,
          deleted: false,
        },
      }
    );
    if (recipientsRes) {
      setRecipients(recipientsRes);
      return true;
    }
    return false;
  }, [schoolIds]);

  // autorequest and update
  useEffect(() => {
    if (autoRequest) {
      handleRequestRecipients(schoolIds);
    }
  }, [autoRequest, schoolIds]);

  return [recipients, loading, handleRequestRecipients];
}
